import React, { Component } from 'react'
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import AddOutlined from '@mui/icons-material/AddOutlined';
import RemoveOutlined from '@mui/icons-material/RemoveOutlined';
import TranslationFields from './TranslationFields';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AddIcon from '@mui/icons-material/Add';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { UpgradePlanHint } from './PricingPlans';

const PREFIX = 'CustomFields';
const classes = {
  root: `${PREFIX}-root`,
  collapseContainer: `${PREFIX}-collapseContainer`,
  divider: `${PREFIX}-divider`,
  label: `${PREFIX}-label`,
  toggleIcon: `${PREFIX}-toggleIcon`,
  cta: `${PREFIX}-cta`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginLeft: '-24px',
    marginRight: '-24px',
    backgroundColor: theme.palette.surfaceRecessed,
    position: 'relative',
  },
  [`& .${classes.collapseContainer}`]: {

  },
  [`& .${classes.divider}`]: {
    //margin: '0 -24px',
  },
  [`& .${classes.label}`]: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    padding: '12px 24px',
    fontSize: '1rem',
    '&.disabled': {
      opacity: .5,
      cursor: 'default'
    }
  },
  [`& .${classes.toggleIcon}`]: {
    margin: '-2px 12px 0 0'
  },
  [`& .${classes.cta}`]: {
    margin: '12px 0',
    padding: '24px 16px',
    textAlign: 'center',
    cursor: 'pointer',
    border: `dashed 1px ${theme.palette.accentSurface.text}`,
    backgroundColor: theme.palette.accentSurface.background,
    '& p': {
      color: theme.palette.accentSurface.text,
    },
    '& span': {
      color: theme.palette.accentSurface.text,
    },
  },
}));

class CustomFields extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      showInfo: true,
      collapsed: true,
      updateNumber: 0,
      anchorEl: null,
    };
  }


  componentWillReceiveProps = (newProps) => {

  }

  handleClick = (evt) => {
    this.setState({
      showInfo: false
    })
  }

  handleToggleCollapse = (evt) => {
    if(this.props.disabled) return null;

    if(this.state.collapsed === true) {
      if(this.props.onExpand) {
        this.props.onExpand(this.props.id)
      }
    }

    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  handleChange = (event, data) => {
    this.props.onChange(null, {
      ...data,
      parentField: this.props.id
    });
  }

  handleOptionsMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleOptionsMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  onClickAddItem = () => {
    this.props.onAddItem(this.props.itemId);
    this.handleOptionsMenuClose();
  }

  render() {
    const {
      t,
      fields,
      isFirst,
      allowAutoTranslation,
      allowFieldFiltering,
    } = this.props;

    const {
      showInfo,
      collapsed,
      anchorEl
    } = this.state;

    return (
      <Root className={classNames('collapsable-fields', isFirst && 'first', this.props.type, this.props.id, classes.root)}>
        <Divider className={classes.divider} />
        <Typography className={classNames(classes.label, this.props.disabled ? 'disabled' : null)} variant="h5" component="p" onClick={this.handleToggleCollapse}>
          {collapsed ? <AddOutlined fontSize={'small'} className={classes.toggleIcon} /> : <RemoveOutlined fontSize={'small'} className={classes.toggleIcon} />}
          {this.props.label}
        </Typography>
        {this.props.locked &&
          <UpgradePlanHint neededPlan={'basic'} position="end" placement="bottom" top={8} isOverlay />
        }
        {!collapsed &&
          <span style={{position: 'absolute', right: '0'}}>
            <IconButton
              style={{padding: '6px', position: 'relative', bottom: '40px', right: '14px'}}
              aria-owns={anchorEl ? 'options-menu' : undefined}
              aria-haspopup="true"
              aria-label="Options list"
              onClick={this.handleOptionsMenuClick}
              size="large">
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="options-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleOptionsMenuClose}
              disableAutoFocusItem
              style={{ top: 56, right: 0 }}
              anchorOrigin={{
                horizontal: 'right',
                vertical: 'top',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={this.onClickAddItem}>
                <AddIcon style={{marginRight:'10px'}}/>
                {t('customContents.addNewCustomContent')}...
              </MenuItem>
            </Menu>
          </span>
        }
        <Collapse
          in={!collapsed}
          mountOnEnter={true}
          unmountOnExit={true}
        >
          <div className={classes.collapseContainer}>
            <Divider className={classes.divider} />
            <TranslationFields
              data={fields}
              nested
              id={this.props.id}
              parentField={'customfields'}
              isPending={this.state.isPending}
              onChange={this.handleChange}
              from={this.props.from}
              to={this.props.to}
              forceUpdate={this.props.forceUpdate}
              triggerClearAllTranslations={this.props.triggerClearAllTranslations}
              triggerDiscardChanges={this.props.triggerDiscardChanges}
              emptyMessage={this.props.emptyMessage}
              allowAutoTranslation={allowAutoTranslation}
              allowFieldFiltering={(this.props.filterQuery !== '')}

              onDeleteItem={this.props.onDeleteItem}
              filterQuery={(this.props.filterQuery !== '') ? this.props.filterQuery : ''}
              type={this.props.type}
            />
          </div>
        </Collapse>
      </Root>
    );
  }
}

export default withTranslation()(CustomFields);
